import { ReactComponent as Barchart } from '../../images/witsmlList/bar_chart.svg';
import { ReactComponent as Transfer } from '../../images/witsmlList/transfer.svg';
import { ReactComponent as Database } from '../../images/witsmlList/database.svg';
import { ReactComponent as Monitoring } from '../../images/witsmlList/monitoring.svg';
import { ReactComponent as ServerIcon } from '../../images/witsmlList/server.svg';

export const tabsData = {
  witsml: {
    key: 'witsml',
    title: 'Разворачиваем WITSML-сервер \n для Вас',
    items: [
      { text: 'Разворачиваем INNERICA WITSML-сервера у Вас', icon: ServerIcon, isInnerica: true },
      { text: 'Сбор данных: ГТИ/СКПБ и MWD/LWD от телесистем', icon: Barchart },
      { text: 'Хранение данных на WITSML-сервере', icon: Database },
      { text: 'Мониторинг через Web-портал INNERICA', icon: Monitoring, isInnerica: true },
    ],
  },
  innerica: {
    key: 'innerica',
    title: 'Передадим данные на WITSML-сервер вашему Заказчику',
    items: [
      { text: 'Сбор данных: ГТИ/СКПБ и MWD/LWD от телесистем', icon: Barchart },
      { text: 'Мониторинг через Web-портал INNERICA', icon: Monitoring, isInnerica: true },
      { text: 'Конвертация в WITSML-формат', icon: Transfer },
      { text: 'Передача на WITSML-сервер Заказчика', icon: ServerIcon },
    ],
  },
};

export type TabItem = {
  text: string;
  icon: React.ComponentType;
  isInnerica?: boolean;
};

export type TabData = {
  key: keyof TabsData;
  title: string;
  items: TabItem[];
};

export type TabsData = {
  witsml: TabData;
  innerica: TabData;
};
export type TabKeys = keyof typeof tabsData;
